import { mapMutations } from 'vuex'
export default {
	data() {
		return {
			shareDialogVisible: false,//分享弹窗
			monthOptions: [
				{ value: 1, label: '01月' },
				{ value: 2, label: '02月' },
				{ value: 3, label: '03月' },
				{ value: 4, label: '04月' },
				{ value: 5, label: '05月' },
				{ value: 6, label: '06月' },
				{ value: 7, label: '07月' },
				{ value: 8, label: '08月' },
				{ value: 9, label: '09月' },
				{ value: 10, label: '10月' },
				{ value: 11, label: '11月' },
				{ value: 12, label: '12月' }
			],
			chineseNumber: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十'],
			SIGNames: [],
			SIGwarehouses: [],
			SIGMaintainers: [],
			//活动方式
			activityMethodOptions: [
				{ value: 1, label: '线上' },
				{ value: 2, label: '线下' }
			],
			//架构选项
			frameworkOptions: [],
			//操作系统选项
			OSOptions: [],
			//文档分类
			documentTypeOptions: [],
			//软件版本
			versionOptions: []
		}
	},

	// 计算属性
	computed: {

		// 截取字符串长度并添加省略号
		replaceText: function () {
			return function (text, numSub) {
				if (text == null) {
					return "";
				}
				if (text.length > numSub) {
					return text.substring(0, numSub - 1) + "...";
				}
				return text;
			}
		},

		// 清除日期具体时间 00:00:00
		clearDateHour: function () {
			let newTime = [];
			return function (val) {
				if (!val) return '';
				newTime = val.split(' ');
				return newTime[0];
			}
		},

		// 根据月份显示英文单词
		replaceMonthEn: function () {
			return function (val) {
				if (!val) return '';
				switch (val) {
					case '01':
						return 'Jan';
						break;
					case '02':
						return 'Feb';
						break;
					case '03':
						return 'Mar';
						break;
					case '04':
						return 'Apr';
						break;
					case '05':
						return 'May';
						break;
					case '06':
						return 'Jun';
						break;
					case '07':
						return 'Jul';
						break;
					case '08':
						return 'Aug';
						break;
					case '09':
						return 'Sept';
						break;
					case '10':
						return 'Oct';
						break;
					case '11':
						return 'Nov';
						break;
					case '12':
						return 'Dec'
				}
			}
		},

		// 当语言处于英语的状态下日期需要转换为日-月-年
		nowEnglishStatus: function () {
			return function (val) {
				if (!val) return '';
				let date = this.clearDateHour(val).split('-');
				return date[2] + '-' + this.replaceMonthEn(date[1]) + '-' + date[0];
			}
		},
		valueToLabel() {//根据值返回文案
			return function (val, arr) {
				let res = {
					label: ''
				};
				if (!arr || arr.length == 0) return res;
				for (let i = 0; i < arr.length; i++) {
					if (String(arr[i].value) == String(val)) {
						res = arr[i];
					}
				};
				return res;
			}
		},
		// 时间格式化 
		dateFormater: function () {
			return function (val, str = 'YYYY-MM-DD') {
				var weeks = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
				// 创建一个新的 Date() 对象并传入时间戳作为参数
				var dateObj = new Date(val);
				// 获取年、月、日等信息
				var year = dateObj.getFullYear(); // 年份
				var month = dateObj.getMonth() + 1; // 月份（注意要加上1）
				var day = dateObj.getDate(); // 日期
				var hours = dateObj.getHours(); // 小时
				var minutes = dateObj.getMinutes(); // 分钟
				var seconds = dateObj.getSeconds(); // 秒钟
				var week = dateObj.getDay();
				return str.replaceAll('YYYY', year)
					.replaceAll('MM', month > 9 ? month : '0' + month)
					.replaceAll('DD', day > 9 ? day : '0' + day)
					.replaceAll('hh', hours > 9 ? hours : '0' + hours)
					.replaceAll('mm', minutes > 9 ? minutes : '0' + minutes)
					.replaceAll('ss', seconds > 9 ? seconds : '0' + seconds)
					.replaceAll('week', weeks[week])
			}
		},

	},
	filters: {
		formatRelativeTime(date) {//相对时间格式化
			const now = new Date();
			const targetDate = new Date(date);
			if (!targetDate) { return '' };
			const diffInSeconds = Math.floor((now - targetDate) / 1000);
			// 时间差转换
			if (diffInSeconds < 60) return "刚刚";
			if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}分钟前`;
			if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)}小时前`;
			// 处理“昨天”
			const yesterday = new Date(now);
			yesterday.setDate(now.getDate() - 1);
			if (targetDate.toDateString() === yesterday.toDateString()) {
				return `昨天 ${targetDate.getHours()}:${targetDate.getMinutes().toString().padStart(2, '0')}`;
			};
			// 更早时间
			const diffInDays = Math.floor(diffInSeconds / 86400);
			if (diffInDays < 7) return `${diffInDays}天前`;
			if (diffInDays < 30) return `${Math.floor(diffInDays / 7)}周前`;
			if (diffInDays < 365) return `${Math.floor(diffInDays / 30)}个月前`;
			// 超过1年显示完整日期
			return targetDate.toLocaleDateString('zh-CN', {
				year: 'numeric',
				month: 'long',
				day: 'numeric'
			});
		}
	},
	methods: {
		...mapMutations(['changeState']),
		
		
		isGoogleGmail(email) {
		  return email.endsWith('@gmail.com') || email.endsWith('@unews.com.tw');
		},
			// 递归处理数据，过滤空children
			filterEmptyChildren(data) {
				return data.map(item => {
					if (item.children && item.children.length === 0) {
						// 如果children为空数组，删除该属性
						return {
							...item,
							children: undefined
						};
					} else if (item.children && item.children.length > 0) {
						// 如果children存在，递归处理
						return {
							...item,
							children: this.filterEmptyChildren(item.children)
						};
					}
					return item;
				});
			},
		  // 生成随机密码的方法
		    generateRandomPassword() {
		      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
		      let password = '';
		      
		      for (let i = 0; i < 8; i++) {
		        const randomIndex = Math.floor(Math.random() * chars.length);
		        password += chars[randomIndex];
		      }
		      
		      return password;
		    },
		handleCopyCodeSuccess(code) {
			const that = this;
			that.$message({
				message: '已复制',
				type: 'success'
			})
		},
		getUnreadMessageCount() {
			const that = this;
			that.$axios.get('member/message/unread').then(res => {
				that.changeState({
					unread: res.data
				});
			}).catch(err => { });
		},
		getCartCount() {
			const that = this;
			that.$axios.get('cart/v2/get-count').then(res => {
				that.changeState({
					cartNum: res.data
				});
			}).catch(err => { });
		},
		updateHistoryKeyword(key) {
			const max = 5;
			let p = JSON.parse(localStorage.getItem('historyKeyword')) || [];
			p.unshift({ value: key });
			let uniqueArr = this.uniqueObjArray(p, 'value');
			let maxArr = uniqueArr;
			if (uniqueArr.length > max) {
				maxArr = uniqueArr.splice(0, max);
			};
			localStorage.setItem('historyKeyword', JSON.stringify(maxArr));
		},
		uniqueObjArray(arr, key) {//对象数组去重
			if (key) {
				// 根据指定key去重
				const map = new Map();
				return arr.filter(item => !map.has(item[key]) && map.set(item[key], true));
			} else {
				// 整个对象去重（完全相同的对象）
				const seen = new Set();
				return arr.filter(item => {
					const str = JSON.stringify(item);
					return seen.has(str) ? false : seen.add(str);
				});
			}
		},
		showShare() {
			this.shareDialogVisible = true;
		},
		beforeImageUpload(file) {
			return file.type.split('/')[0] == 'image'
		},
		downloadResourceFiles(urls) {//文件下载
			const that = this;
			if (!urls || urls.length == 0) {
				this.$message({
					message: '未选择文件',
					type: 'error'
				});
				return;
			};
			for (let i = 0; i < urls.length; i++) {
				if (urls[i].url) {
					const a = document.createElement('a');
					a.href = urls[i].url;
					a.download = urls[i].name || '';
					a.target = '_blank';
					document.body.appendChild(a);
					a.click();
					document.body.removeChild(a);
					if (urls[i].id) {
						that.$axios.post('front/resources-software/count-download', { softwareId: urls[i].id }).then(r => { }).catch(e => { });
					};
					if (localStorage.getItem('Authorization')) {
						that.$axios.post('member/download/save', { fileUrl: urls[i].url }).then(r => { }).catch(e => { });
					};
				}
			}
		},
		downloadFiles(urls) {//文件下载
			const that = this;
			if (!urls || urls.length == 0) {
				this.$message({
					message: '未选择文件',
					type: 'error'
				});
				return;
			};
			for (let i = 0; i < urls.length; i++) {
				if (urls[i].url) {
					const a = document.createElement('a');
					a.href = urls[i].url;
					a.download = urls[i].name || '';
					a.target = '_blank';
					document.body.appendChild(a);
					a.click();
					document.body.removeChild(a);
					if (urls[i].id) {
						that.$axios.post('front/version-release-software/count-download', { softwareId: urls[i].id }).then(r => { }).catch(e => { });
					};
					if (localStorage.getItem('Authorization')) {
						that.$axios.post('member/download/save', { fileUrl: urls[i].url }).then(r => { }).catch(e => { });
					};
				}
			}
		},
		valuesToLabels(val, arr) {
			let res = [];
			if (!arr || arr.length == 0 || !Array.isArray(val) || val.length == 0) return [];
			val.forEach(i => {
				arr.forEach(j => {
					if (j.value == i) {
						res.push(j)
					}
				});
			});
			return res
		},
		getSIGOptions() {
			const that = this;
			that.$axios.post('dict-data/list', { dictType: 'promotion_article_sig_name' }).then(res => {
				that.SIGNames = res.data;
			}).catch(err => { });
			that.$axios.post('dict-data/list', { dictType: 'promotion_article_warehouse_name' }).then(res => {
				that.SIGwarehouses = res.data;
			}).catch(err => { });
			that.$axios.post('dict-data/list', { dictType: 'promotion_article_maintainer' }).then(res => {
				that.SIGMaintainers = res.data;
			}).catch(err => { })
		},
		getDownloadFilterOptions() {
			const that = this;
			that.$axios.post('dict-data/list', { dictType: 'version_release_architecture' }).then(res => {
				that.frameworkOptions = res.data;
			}).catch(err => { });
			that.$axios.post('dict-data/list', { dictType: 'version_release_os' }).then(res => {
				that.OSOptions = res.data;
			}).catch(err => { });
		},
		getDocumentFilterOptions() {
			const that = this;
			let arr = [
				that.$axios.post('dict-data/list', { dictType: 'document_category' }).then(res => res.data).catch(err => { }),
				that.$axios.post('dict-data/list', { dictType: 'document_software_version' }).then(res => res.data).catch(err => { })
			];
			Promise.all(arr)
				.then(res => {
					that.documentTypeOptions = res[0];
					that.versionOptions = res[1];
				})
				.catch(err => { });
		},
		domHTML(content) {
			const parser = new DOMParser();
			const doc = parser.parseFromString(content, 'text/html');
			doc.querySelectorAll('pre').forEach(p => {
				const lang = p.getAttribute('class').split(';')[0].split(':')[1];
				const oldHtml = p.innerHTML;
				p.setAttribute('data-content',p.textContent);
				const c = document.createElement('code');
				c.setAttribute('class', 'language-' + lang + ' overscroll');
				c.innerHTML = oldHtml;
				p.innerHTML = '';
				p.append(c);
			});
			return doc.body.innerHTML;
		}
	}
}